/**
 * DictListType
 * 字典数据类型
 */
export const dictListCodes = [
  "1029",
  "1031",
  "1032",
  "1047",
  "1048",
  "1056",
  "1060",
  "1066",
  '1055',
  '1052',
];

export type DictResType = {
  code: string;
  infoList: DictInfoListType[];
  name: string;
  remarks: string;
};

export type DictInfoListType = {
  label: string;
  value: string;
  remarks: string;
};
